module.exports = __webpack_public_path__ + "static/media/comp-screening-s.4a5e17e2.jpg";